import { Box } from '@chakra-ui/react';
import { DashboardTemplate } from '../../components/templates/DashboardTemplate.tsx';
import { SyncClientsMetadataTab } from '../BooksReportTabs/tabs/SyncClientsMetadataTab.tsx';

export default function ClientesSincronizadosPage() {
  return (
    <DashboardTemplate>
      <Box width="100%" maxW="100%">
        <SyncClientsMetadataTab />
      </Box>
    </DashboardTemplate>
  );
}
